module.exports = __webpack_public_path__ + "static/media/Icon_11.9397ae13.svg";